import React from 'react';
const items = [{
  name: 'Les 6 Tomes Functional Clé en Main',
  value: '97€'
}, {
  name: 'Women Functional Premium',
  value: '57€'
}, {
  name: 'Mobility & Recovery System',
  value: '47€'
}, {
  name: 'Programmation 12 Semaines',
  value: '67€'
}, {
  name: '6 Bonus Premium',
  value: '97€'
}];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-bg-dark py-14 sm:py-28 px-4 sm:px-6 relative overflow-hidden border-y border-border-light" data-id="element-223">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/15 rounded-full blur-[150px] pointer-events-none" data-id="element-224"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-cta-green/10 rounded-full blur-[100px] pointer-events-none" data-id="element-225"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-226">
        <h2 className="font-display text-3xl sm:text-6xl font-bold text-white text-center mb-6 sm:mb-16 tracking-tight uppercase" data-id="element-227">
          💰 Offre Spéciale de Lancement
        </h2>

        <div className="bg-bg-alt rounded-sm border border-primary/40 shadow-[0_20px_60px_-20px_rgba(242,92,37,0.4)] px-5 py-8 sm:p-14 flex flex-col relative w-full sm:w-[95%] mx-auto" data-id="element-228">
          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-primary text-white font-display font-bold text-[10px] sm:text-base px-5 sm:px-8 py-1.5 sm:py-2.5 rounded-sm whitespace-nowrap shadow-[0_8px_20px_rgba(242,92,37,0.5)] uppercase tracking-wider" data-id="element-229">
            ⭐ L'option la plus choisie
          </div>

          <p className="font-display text-sm sm:text-3xl font-bold text-white text-center mt-2 sm:mt-4 mb-4 sm:mb-10 tracking-wider uppercase" data-id="element-230">
            Contenu du Système :
          </p>

          <div className="space-y-2 sm:space-y-4 mb-4 sm:mb-10 text-sm sm:text-xl" data-id="element-231">
            {items.map((item, i) => <div key={i} className="flex justify-between text-white font-medium border-b border-border-light pb-2 sm:pb-3 gap-3" data-id="element-232">
                <span className="flex items-start gap-2" data-id="element-233">
                  <span className="text-primary mt-0.5" data-id="element-234">✓</span>
                  {item.name}
                </span>
                <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-235">
                  {item.value}
                </span>
              </div>)}
            <div className="flex justify-between text-white font-display font-bold pt-2 sm:pt-4 text-base sm:text-2xl uppercase tracking-wide" data-id="element-236">
              <span data-id="element-237">Valeur Totale :</span>
              <span className="text-badge-red line-through" data-id="element-238">365€</span>
            </div>
          </div>

          <div className="text-center mb-4 sm:mb-10 bg-primary/8 border border-primary/40 py-5 sm:py-8 rounded-sm relative overflow-hidden" data-id="element-239">
            <div className="absolute top-0 left-0 w-full h-1 bg-primary" data-id="element-240"></div>
            <div className="absolute bottom-0 left-0 w-full h-1 bg-primary" data-id="element-241"></div>
            <p className="text-primary font-display font-bold mb-2 sm:mb-4 text-xs sm:text-lg uppercase tracking-[0.2em]" data-id="element-242">
              Prix Aujourd'hui (93% DE RÉDUCTION) :
            </p>
            <div className="font-display text-white font-bold text-5xl sm:text-8xl tracking-tighter leading-none flex items-center justify-center gap-2 sm:gap-4" data-id="element-243">
              <span data-id="element-244">🏆</span>
              <span data-id="element-245">24€</span>
            </div>
            <div className="text-text-sec text-xs sm:text-base font-medium mt-2 uppercase tracking-wider" data-id="element-246">
              (Paiement unique — Accès à vie)
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-secondary font-bold text-[10px] sm:text-sm bg-secondary/15 px-4 py-1.5 rounded-sm border border-secondary/40 animate-pulse mx-auto mb-4 sm:mb-6 uppercase tracking-wider" data-id="element-247">
            ⏰ Prix de lancement — temporaire
          </span>

          <a href="https://italia.digitalpack.shop/cart/54203301822739:1" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Functional Clé en Main — Système Complet',
              content_type: 'product',
              value: 24,
              currency: 'EUR'
            });
          }
        }} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-display font-bold text-base sm:text-2xl py-4 sm:py-6 rounded-sm hover:bg-cta-green-hover transition-all shadow-[0_15px_40px_-10px_rgba(22,163,74,0.5)] mb-3 sm:mb-6 uppercase tracking-wide border border-white/10" data-id="element-248">
            🚀 OUI ! JE VEUX FUNCTIONAL CLÉ EN MAIN
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap uppercase tracking-wider" data-id="element-249">
            <span data-id="element-250">⚡ Accès immédiat</span>
            <span data-id="element-251">•</span>
            <span data-id="element-252">🛡️ Garantie 7 Jours</span>
            <span data-id="element-253">•</span>
            <span data-id="element-254">💳 Paiement Sécurisé</span>
          </p>
        </div>
      </div>
    </section>;
}